export const GET_POSTS = "GET_POSTS";
export const GET_MOST_READ_POSTS = "GET_MOST_READ_POSTS";
export const SET_POSTS = "SET_POSTS";
export const SET_MOST_READ_POSTS = "SET_MOST_READ_POSTS";